
export function parseLocationSuggestions (payload) {
  const locationSuggestions = []
  payload.forEach((place) => {
    const loc = place.geometry.location
    const formattedCoords = `${loc.lat()},${loc.lng()}`
    locationSuggestions.push({
      value: formattedCoords,
      label: place.formatted_address,
    })
  })
  return locationSuggestions
}

export function parseCitySuggestions (payload) {
  return payload.map((city) => {
    return {
      label: city.label,
      value: `/${city.country}/${city.value}/`,
    }
  })
}
